<template>
	<j-card class="bt1 bc7 bg5">
		<pdf-template-attachments
			:options="listOfTemplates"
			:attachedFiles="attachedTemplates"
			@added:attachment="$emit('added:attachment')"
			@updated:attachment="$emit('updated:attachment')"
			@removed:attachment="$emit('removed:attachment')"
		/>
		<file-attachments
			:attachedFiles="attachedFiles"
			@added:attachment="$emit('added:attachment')"
			@updated:attachment="$emit('updated:attachment')"
			@removed:attachment="$emit('removed:attachment')"
		/>
	</j-card>
</template>

<script>
import JCard from "@/components/JCard"
import PdfTemplateAttachments from "./PdfTemplateAttachments"
import FileAttachments from "./FileAttachments"

export default {
	props: {
		// list of possible attachments
		listOfTemplates: Array,
		// templates already attached to this email template
		attachedTemplates: Array,
		// files already attached to this email template
		attachedFiles: Array
	},

	components: {
		JCard,
		PdfTemplateAttachments,
		FileAttachments
	}
}
</script>